import React from 'react';
import '../styles/AirportTransfer.css';

const AirportTransfer = () => {
  const airports = [
    {
      id: 1,
      name: 'Heathrow Airport',
      code: 'LHR',
      descriptionOne: 'Taxi 24hrs provides reliable airport transfers to and from Heathrow Airport with professional drivers and comfortable vehicles.',
      descriptionTwo: 'Travel with confidence and enjoy a smooth, punctual, and stress-free journey every time.'
    },
    {
      id: 2,
      name: 'Gatwick Airport',
      code: 'LGW',
      descriptionOne: 'Taxi 24hrs offers efficient airport transfer services to Gatwick Airport, ensuring timely pickups and drop-offs.',
      descriptionTwo: 'Our experienced drivers make every journey safe, comfortable, and hassle-free.'
    },
    {
      id: 3,
      name: 'Manchester Airport',
      code: 'MAN',
      descriptionOne: 'Taxi 24hrs provides dependable transportation to Manchester Airport for both business and leisure travelers.',
      descriptionTwo: 'Enjoy a comfortable ride with professional drivers and excellent customer service.'
    },
    {
      id: 4,
      name: 'Stansted Airport',
      code: 'STN',
      descriptionOne: 'Taxi 24hrs delivers reliable airport transfer services to Stansted Airport with a focus on.',
      descriptionTwo: 'We ensure every passenger reaches their destination safely and on time.'
    },
    {
      id: 5,
      name: 'Luton Airport',
      code: 'LTN',
      descriptionOne: 'Taxi 24hrs offers convenient and affordable transfers to and from Luton Airport.',
      descriptionTwo: 'Our modern vehicles and experienced drivers guarantee a smooth travel experience.'
    },
    {
      id: 6,
      name: 'Birmingham Airport',
      code: 'BHX',
      descriptionOne: 'Taxi 24hrs provides professional airport transportation services to Birmingham Airport.',
      descriptionTwo: 'Count on us for timely pickups, comfortable rides, and dependable service.'
    },
    {
      id: 7,
      name: 'Edinburgh Airport',
      code: 'EDI',
      descriptionOne: 'Taxi 24hrs offers reliable transfers to Edinburgh Airport with a strong focus on customer.',
      descriptionTwo: 'Enjoy stress-free travel with punctual service and experienced local drivers.'
    },
    {
      id: 8,
      name: 'Glasgow Airport',
      code: 'GLA',
      descriptionOne: 'Taxi 24hrs provides safe and efficient airport transfer services to Glasgow Airport.',
      descriptionTwo: 'Travel comfortably in well-maintained vehicles driven by professional chauffeurs.'
    },
    {
      id: 9,
      name: 'Bristol Airport',
      code: 'BRS',
      descriptionOne: 'Taxi 24hrs offers dependable transportation to Bristol Airport for individuals, families.',
      descriptionTwo: 'We ensure a comfortable and timely journey from start to finish.'
    },
    {
      id: 10,
      name: 'Newcastle Airport',
      code: 'NCL',
      descriptionOne: 'Taxi 24hrs provides reliable airport transfers to Newcastle Airport with a commitment to quality.',
      descriptionTwo: 'Our drivers ensure every journey is smooth, safe, and stress-free.'
    },
    {
      id: 11,
      name: 'Liverpool John Lennon Airport',
      descriptionOne: 'Taxi 24hrs offers professional airport transfer services to Liverpool John Lennon Airport.',
      descriptionTwo: 'Enjoy punctual pickups and comfortable travel at competitive prices.'
    },
    {
      id: 12,
      name: 'East Midlands Airport',
      code: 'EMA',
      descriptionOne: 'Taxi 24hrs provides efficient and reliable transportation to East Midlands Airport.',
      descriptionTwo: 'We focus on delivering a comfortable journey with excellent customer care.'
    },
    {
      id: 13,
      name: 'Aberdeen Airport',
      code: 'ABZ',
      descriptionOne: 'Taxi 24hrs offers long-distance airport transfer services to Aberdeen Airport with comfort.',
      descriptionTwo: 'Our experienced drivers ensure a relaxing and safe travel experience.'
    },
    {
      id: 14,
      name: 'Belfast International Airport',
      descriptionOne: 'Taxi 24hrs provides dependable airport transportation to Belfast International Airport.',
      descriptionTwo: 'Enjoy professional service, punctual arrivals, and a hassle-free journey.'
    },
    {
      id: 15,
      name: 'London City Airport',
      code: 'LCY',
      descriptionOne: 'Taxi 24hrs offers fast and reliable transfers to London City Airport for all types of travelers.',
      descriptionTwo: 'Travel with confidence knowing your airport journey is in safe hands.'
    }
  ];

  return (
    <section id="transfers" className="airport-transfer">
      <div className="airport-container">
        <div className="airport-intro">
          <div className="airport-intro-content">
            <h2 className="airport-title">Airport Transfers</h2>
            <p className="airport-subtitle">
              Taxi 24hrs provides reliable and professional airport transfer services, ensuring a smooth and stress-free journey for every passenger. Taxi 24hrs focuses on punctuality with on-time pickups and drop-offs, so you never have to worry about missing a flight. With experienced drivers, comfortable vehicles, and excellent customer service, Taxi 24hrs guarantees a safe and relaxing travel experience. Whether you are traveling for business or leisure, Taxi 24hrs makes airport transportation simple, convenient, and dependable. Additionally, Taxi 24hrs monitors flight schedules to adjust pickup times according to delays or early arrivals, ensuring maximum convenience and peace of mind for customers.
            </p>
          </div>
          <div className="airport-intro-image-wrap">
            <img src="/images/airport.jpg" alt="Airport transfer service" className="airport-intro-image" />
          </div>
        </div>
        
        <div className="airport-grid">
          {airports.map(airport => (
            <article key={airport.id} className="airport-card">
              <div className="airport-heading">
                <h3 className="airport-name">{airport.code ? `${airport.name} (${airport.code})` : airport.name}</h3>
              </div>
              <p className="airport-description">{airport.descriptionOne}</p>
              <p className="airport-description">{airport.descriptionTwo}</p>
              <a
                href="https://booktaxinow.co.uk/"
                className="airport-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Airport Transfer
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AirportTransfer;
